import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ShieldCheck } from "lucide-react";
import { defineModuleUi, from, unwrap, useOrg } from "@vixio/data";
import { StatusFromMap, formatDate, lazyPage } from "@vixio/ui";
import { INCIDENT_STATUS, type IncidentView } from "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const CompliancePage = lazyPage(() => import("./CompliancePage"), "CompliancePage");
const IncidentPage = lazyPage(() => import("./IncidentPage"), "IncidentPage");
const DpiaPage = lazyPage(() => import("./DpiaPage"), "DpiaPage");

function IncidentsWidget() {
  const org = useOrg();
  const q = useQuery({
    queryKey: ["compliance", "widget", org.id],
    queryFn: () => unwrap<IncidentView[]>(from("compliance", "v_incidents").select("*").eq("org_id", org.id).neq("status", "encerrado").order("anpd_due_on").limit(5)),
  });
  if (!q.data?.length) return <p className="muted">Nenhum incidente aberto.</p>;
  return (
    <ul className="vx-stack" style={{ gap: 8, margin: 0, padding: 0, listStyle: "none" }}>
      {q.data.map((i) => (
        <li key={i.id} className="vx-row vx-row--between" style={{ flexWrap: "nowrap" }}>
          <span style={{ minWidth: 0 }}>
            <Link to={`/gestao/conformidade/incidentes/${i.id}`}>{i.code}</Link>
            <span className="text-2">
              {" · "}
              {i.anpd_notified_at || i.relevant_risk === false ? i.title : `ANPD até ${formatDate(i.anpd_due_on)}`}
            </span>
          </span>
          <StatusFromMap map={INCIDENT_STATUS} value={i.status} />
        </li>
      ))}
    </ul>
  );
}

export default defineModuleUi({
  key: "compliance",
  title: "Conformidade",
  domain: "governance",
  icon: ShieldCheck,
  menu: [{ path: "/gestao/conformidade", label: "Conformidade (LGPD)", minRole: "member", icon: ShieldCheck, order: 30, keywords: "lgpd encarregado dpo ropa dpia incidente anpd retenção política privacidade operador" }],
  routes: [
    { path: "/gestao/conformidade", element: <CompliancePage />, minRole: "member" },
    { path: "/gestao/conformidade/incidentes/:id", element: <IncidentPage />, minRole: "manager" },
    { path: "/gestao/conformidade/dpia/:id", element: <DpiaPage />, minRole: "member" },
  ],
  widgets: [{ key: "compliance.incidents", title: "Incidentes LGPD", minRole: "manager", span: 1, order: 70, element: IncidentsWidget }],
});
